import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfitCenter } from '../store/slices/profitCenterSlice';
import { AppState } from '../store/store';
import get from 'lodash/get';

export const useProfitCenter = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.profitCenter);

  useEffect(() => {
    dispatch(fetchProfitCenter({ limit: 1000 }));
  }, []);

  return {
    items: get(findAll, 'payload.items', [])
  };
};
